import React from "react"
import { cn } from "../../lib/utils"

const buttonVariants = {
  variant: {
    default: "bg-colors-blue-600 text-white hover:bg-colors-blue-700",
    destructive: "bg-colors-red-600 text-white hover:bg-colors-red-700",
    outline: "border border-neutral-gray300 bg-white hover:bg-neutral-gray50",
    secondary: "bg-neutral-gray100 text-neutral-gray900 hover:bg-neutral-gray200",
    ghost: "hover:bg-neutral-gray100",
    link: "text-colors-blue-600 underline-offset-4 hover:underline",
  },
  size: {
    default: "h-10 px-4 py-2",
    sm: "h-9 rounded-md px-3",
    lg: "h-11 rounded-md px-8",
    icon: "h-10 w-10",
  },
}

const Button = React.forwardRef(
  ({ className, variant = "default", size = "default", ...props }, ref) => {
    return (
      <button
        className={cn(
          "inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-colors-blue-600 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
          buttonVariants.variant[variant],
          buttonVariants.size[size],
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }